import React, { useEffect, useState } from 'react';
import { Modal, Typography, Divider, Paper, Button, TextField, Box, CircularProgress } from '@mui/material';
import CuentasTableEasy from '../../agent/CuentasTableEasy';
import apiInstance from '../../../services/ServiceApi';
import TipificacionEasy from '../../agent/TipificacionEasy';
import ToastMessage from '../../utilities/ToastMessage';
import AudioPlayer from './Recording';
import FormularioRellenoBO from '../../LineaNegocio/formulario/FormularioRellenoBO';

const DataVenta = ({ open, onClose, datos, campos,handleUpdate }) => {
  const [clienteDetalle, setClienteDetalle] = useState(null);
  const [dataCuentas, setDataCuentas] = useState(null);
  const [dataTipificaciones, setDataTipificaciones] = useState(null);
  const [loadingTipificaciones, setLoadingTipificaciones] = useState(true);
  const [selectedValues, setSelectedValues] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [observacion, setObservation] = useState('');
  const [openToast, setOpenToast] = useState(false);
  const [mensajeToast, setMensajeToast] = useState({});
  const [severity, setSeverity] = useState('success');
  const user = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    const fetchClienteDetalle = async () => {
      try {
        const response = await apiInstance.get(`clienteDetalle/`, {
          params: { identificador: datos.cliente__identificador, id_linea_negocio: datos.cliente__linea_negocio_id }
        });
        setClienteDetalle(response.data);
      } catch (error) {
        console.error('Error al obtener los detalles del cliente:', error);
      }
    };

    if (open) {
      fetchClienteDetalle();
    }
  }, [open, datos]);

  const fetchTipificaciones = async () => {
    try {
      if (datos.cliente__linea_negocio_id) {
        const response = await apiInstance.get("tipificaciones/", { params: { linea_negocio: datos.cliente__linea_negocio_id, tipo: 2 } });
        console.log(response.data)
        setDataTipificaciones(response.data);
        setLoadingTipificaciones(false);
      }
    } catch (error) {
      console.error('Error al obtener las tipificaciones:', error);
      setLoadingTipificaciones(false);
    }
  };
  

  useEffect(() => {
    fetchTipificaciones();
  }, [apiInstance, datos.cliente__linea_negocio_id]);

  const handleSelectsChange = (newSelects) => {
    const allSelected = newSelects.every((select) => select.selected !== "");
    setAllSelected(allSelected);
  };

  const handleValidarClick = async () => {
    if (selectedValues.some(sel => sel.venta === true) && datos.datos === null) {
      alert('Debe rellenar la ficha de venta');
      return;
    }
    if (!allSelected) {
      alert("Por favor, selecciona una opción en todos los selects.");
      return;
    }

    try {
      setIsLoading(true);

      const dataTipificacion = {
        cuenta: clienteDetalle,
        tipificacion: selectedValues,
        venta_id: datos.id,
        identificador: datos.cliente__identificador,
        linea_negocio: datos.cliente__linea_negocio_id,
        codigo_llamada: '-1',
        estado_validacion_id: selectedValues.pop().codigo_discador,
        numero_contactado: '',
        idCliente: datos.cliente__id,
        codigo_usuario: user.id,
        observacion: observacion
      };

      const response = await apiInstance.post('saveValidacionVenta/', dataTipificacion);

      setIsLoading(false);
      setOpenToast(true);
      setMensajeToast({ "Succes": "VALIDACION GUARDADA CORRECTAMENTE" });
      setSeverity('success');
      onClose();
      handleUpdate();
    } catch (error) {
      setIsLoading(false);
      setOpenToast(true);
      setMensajeToast({ "error": "Ocurrió un error al guardar la validación" });
      setSeverity('error');
      setSelectedValues([]);
    }
  };

  const handleSelectChange = (selectedOption) => {
    if (!selectedOption) return;

    setSelectedValues(values => {
      const updatedValues = values.filter(value => value.id !== selectedOption.id);

      const newSelectedValue = {
        id: selectedOption.id,
        venta: selectedOption.venta,
        codigo_discador: selectedOption.codigo_discador,
        tipificacion: selectedOption.tipificacion,
      };

      updatedValues.push(newSelectedValue);

      return updatedValues;
    });
  };

  const handleCloseToast = () => {
    setOpenToast(false);
  };

  return (
    <>
      {openToast && <ToastMessage severity={severity} open={openToast} msg={mensajeToast} onClose={handleCloseToast} />}

      <Modal open={open} onClose={onClose}>
        <Paper sx={{
          padding: 2,
          maxWidth: '90%',
          margin: 'auto',
          marginTop: '5%',
          maxHeight: '80vh',
          overflow: 'auto'
        }}>
          <Box>
            <Typography variant="h6">Datos de Ficha:</Typography>
            {datos && campos && clienteDetalle && (
              <Box mt={2}>
                <FormularioRellenoBO valoresIniciales={datos.datos} campos={campos} venta={datos.id}  
                  identificador={datos.cliente__identificador}
                  id_linea_negocio={datos.cliente__linea_negocio_id} 
                  cuenta_cliente ={datos.data_cliente} />
              </Box>
            )}
          </Box>
          <Divider sx={{ my: 2 }} />
          <Box>
            <Typography variant="h6">Datos del Cliente:</Typography>
            <Typography variant="body1">Numero de Documento del Cliente: {datos.cliente__numero_documento}</Typography>
            <Typography variant="body1">Nombre del Cliente: {datos.cliente__nombre_completo}</Typography>
            <Typography variant="body1">Edad del Cliente: {datos.cliente__edad}</Typography>
            <Typography variant="body1">Id Cliente: {datos.cliente__id}</Typography>
          </Box>
          <Divider sx={{ my: 2 }} />
          <Box>
            <Typography variant="h6">Detalle del Cliente:</Typography>
            {clienteDetalle && <CuentasTableEasy data={clienteDetalle} />}
          </Box>
          <Divider sx={{ my: 2 }} />
          <Box>
            {/*<Typography variant="h6">Audios Relacionados</Typography>
            <AudioPlayer uniqueid={datos.uniqueid} phone={datos.uniqueid} />*/}
          </Box>
          <Divider sx={{ my: 2 }} />
          
          <Box>
            <Typography variant="h6">Tipificar</Typography>
            {loadingTipificaciones ? (
              <CircularProgress />
            ) : (
              <TipificacionEasy data={dataTipificaciones} onChange={handleSelectChange} onSelectsChange={handleSelectsChange} />
            )}
          </Box>
          <Box m={2}>
            <TextField
              label="Observación"
              sx={{ width: '100%' }} 
              multiline
              value={observacion}
              onChange={(e) => setObservation(e.target.value)}
            />
          </Box>
          <Divider sx={{ my: 2 }} />
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 2 }}>
            {isLoading ? (
              <CircularProgress />
            ) : (
              <>
                <Button variant="contained" style={{ backgroundColor: 'red', color: 'white' }} onClick={onClose} sx={{ padding: 2 }}>
                  Cancelar
                </Button>
                <Button variant="contained" color="primary" onClick={handleValidarClick} sx={{ padding: 2 }}>
                  Guardar
                </Button>
              </>
            )}
          </Box>
        </Paper>
      </Modal>
    </>
  );
};

export default DataVenta;
